import { BottomSheetHeader, Box, type TextRef } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import useFocusOnNavigation from "../../../../hooks/useFocusOnNavigation";
import { CloseButton } from "../../JobComponent/CloseButton";

import { spacing } from "@indeed/ifl-tokens/react-native";
import { useNavigation } from "@react-navigation/native";
import React, { useRef } from "react";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function ReportContentHeader() {
  const gt = useI18n();
  const navigation = useNavigation();
  const titleRef = useRef<TextRef>(null);

  // Focus the title when the screen comes into focus for better accessibility
  useFocusOnNavigation(titleRef);

  // Using useSafeAreaInsets() to handle the safe area padding instead of SafeAreaView,
  // as SafeAreaView can cause inconsistent results between the first load and subsequent loads.
  const { top } = useSafeAreaInsets();

  return (
    <BottomSheetHeader
      title={gt.pgettext("description of report job feature", "Report this job")}
      showBorder={false}
      showGrabber={false}
      sx={{
        paddingTop: Platform.OS === "ios" ? spacing.s4 : top,
      }}
      titleRef={titleRef}
      headerRight={
        <Box sx={{ paddingRight: spacing.s4 }}>
          <CloseButton
            onPress={() => navigation.goBack()}
            accessibilityLabel={gt.gettext("Close")}
          />
        </Box>
      }
    />
  );
}
